<template lang="pug">
CustomInputSelectJson.area-selector(
  :value='value'
  @input='$emit(`input`, $event)'
  :options='availableZones'
)
</template>

<script>
export default {
  props: {
    value: {},
  },
  data: () => ({
    availableZones: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const res = await this.$api.admin.permissions.getUserAreas();
        this.availableZones = res.data;
      } catch (e) {
        console.log(JSON.stringify(e));
      }
    },
  },
};
</script>

<style lang="scss">
.area-selector {
  width: 100px;
}
</style>
